import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    IncidentImplementationComponent,
    IncidentReportComponent,
    IncidentReviewComponent,
    IncidentsOverviewComponent
} from 'sms-dashboard/incidents';
import { SafetySidebarComponent } from '../safety-sidebar/safety-sidebar.component';

/**
 * Routes for the Incidents section of the workspace: the SMS incident overview,
 * reporting, review and implementation screens, with the shared safety
 * navigation in the sidebar outlet.
 */
@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: IncidentsOverviewComponent,
                pathMatch: 'full'
            },
            {
                path: 'new',
                component: IncidentReportComponent
            },
            {
                path: ':id/edit',
                component: IncidentReportComponent
            },
            {
                path: ':id/review',
                component: IncidentReviewComponent
            },
            {
                path: ':id/implementation',
                component: IncidentImplementationComponent
            },
            {
                path: '',
                component: SafetySidebarComponent,
                outlet: 'sidebar'
            }
        ])
    ],
    exports: [RouterModule]
})
export class IncidentsRoutingModule {}
